module.exports = __webpack_public_path__ + "img/ebla-6.cd218050.jpeg";